module.exports = __webpack_public_path__ + "media/alaska/trees-580d452c.jpg";